import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { useI18n } from '../i18n/i18n';
import { useSEO } from '../hooks/useSEO';

export const EmailVerifiedClosePage: React.FC = () => {
  const { t } = useI18n();
  
  // SEO: Private confirmation page - prevent indexing
  const seoContent = useSEO({
    title: 'Email Verified | Finanzly',
    description: 'Your email has been successfully verified.',
    noindex: true,
  });

  useEffect(() => {
    // Close the tab/window after a short delay
    const timer = setTimeout(() => {
      // Try to close the window/tab
      window.close();
      
      // If window.close() doesn't work (due to browser restrictions),
      // show a message to the user
      const closeMessage = document.getElementById('close-message');
      if (closeMessage) {
        closeMessage.style.display = 'block';
      }
    }, 2000); // 2 second delay to show the success message

    return () => clearTimeout(timer);
  }, []);

  const handleManualClose = () => {
    window.close();
  };

  return (
    <>
      {seoContent}
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <CheckCircle className="mx-auto h-16 w-16 text-green-500" />
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900">
            {t('auth.verification.emailVerified')}
          </h1>
          <p className="mt-2 text-lg text-gray-600">
            {t('auth.verification.verificationSuccess')}
          </p>
          <p className="mt-4 text-sm text-gray-500">
            {t('auth.verification.tabWillClose')}
          </p>
          
          {/* Message shown if auto-close doesn't work */}
          <div id="close-message" style={{ display: 'none' }} className="mt-6">
            <p className="text-sm text-gray-600">
              {t('auth.verification.pleaseCloseTab')}
            </p>
            <button
              onClick={handleManualClose}
              className="mt-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#EA580C] hover:bg-[#C2410C] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#EA580C]"
            >
              {t('auth.verification.closeTab')}
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
